module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcBAMAAADy7KARAAAAAXNSR0IArs4c6QAAAC1QTFRFAAAAQEBAMzMzOTk5PT09NTU1Ozs7MzMzNDQ0NDQ0NDQ0MzMzNDQ0MzMzMzMzmT/5zAAAAA50Uk5TAAgKEhUYGjI2dXZ88fSvhxiOAAAAP0lEQVQY02NgQAfs5SgggIHvHQrYQIQA710UsICBJoDZGAUIkONSDAEWFxSgQBun85xBARPIcSlHBwpIwLAEAP3Kt4ZYqPIwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/hum.png
// module id = GSGi
// module chunks = 0